<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12>
        <v-card color="semBl" width="100%">
          <v-card-text>
            <v-autocomplete
              v-model="project"
              hint="Seleccione el proyecto, para ver los detalles"
              :items="projects"
              label="Proyectos"
              persistent-hint
              prepend-icon="mdi-book-open-page-variant"
              no-data-text="No se tienen proyectos"
              color="semAz"
              class="title font-weight-medium"
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex d-flex>
        <v-tabs
          v-model="tabs"
          centered
          color="semBl"
          slider-color="semRj"
          active-class="semRj--text"
          icons-and-text
          show-arrows
          :key="tabsKey"
        >
          <v-tab href="#tab-dataSheet">
            Ficha Técnica
            <v-icon right>mdi-cards-outline</v-icon>
          </v-tab>

          <v-tab href="#tab-synthesis">
            Síntesis
            <v-icon right>mdi-sign-caution</v-icon>
          </v-tab>

          <v-tab href="#tab-traceability">
            Trazabilidad
            <v-icon right>mdi-checkbox-multiple-marked-circle-outline</v-icon>
          </v-tab>

          <v-tab href="#tab-reflections">
            Reflexiones
            <v-icon right>mdi-check-all</v-icon>
          </v-tab>

          <!-- <v-tab href="#tab-recommendations">
            Recomendaciones
            <v-icon right>mdi-comment-alert</v-icon>
          </v-tab> -->

          <!-- vistas -->
          <v-tab-item
            :value="'tab-dataSheet'"
          >
            <v-card flat width="100%">
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-card>
                      <v-toolbar color="semAz" dark>
                        <v-toolbar-title>IEO en las que se Aplicó el Proyecto</v-toolbar-title>
                      </v-toolbar>

                      <v-list>
                        <template v-for="(sch, index) in prjSchools[project]">
                          <v-list-tile
                            :key="index"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ sch.ieo }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider
                            v-if="index + 1 < prjSchools[project].length"
                            :key="index"
                          ></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card>
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Objetivo</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text>
                            {{ prjObj }}
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex xs12>
                        <v-card>
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Actores</v-toolbar-title>
                          </v-toolbar>

                          <template v-for="(act, index) in prjAct">
                            <v-card-text
                              :key="index"
                            >
                              {{ act }}
                            </v-card-text>
                          </template>
                        </v-card>
                      </v-flex>

                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex d-flex xs12 sm6>
                            <v-card>
                              <v-toolbar color="semAz" dark>
                                <v-toolbar-title>Problema</v-toolbar-title>
                              </v-toolbar>

                              <v-card-text>
                                {{ prjPrb }}
                              </v-card-text>
                            </v-card>
                          </v-flex>

                          <v-flex d-flex xs12 sm6>
                            <v-card>
                              <v-toolbar color="semAz" dark>
                                <v-toolbar-title>Impacto</v-toolbar-title>
                              </v-toolbar>

                              <v-card-text>
                                {{ prjImp }}
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12>
                        <v-card>
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Número de IEO Participantes</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text>
                            {{ prjCnt }}
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex xs12>
                        <v-card flat class="text-xs-center">
                          <v-card-text>
                            <v-btn
                              color="semRj"
                              class="white--text"
                              :href="dataSheetLink"
                              target="_blank"
                            >
                              Descargar Ficha Técnica
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab-item
            :value="'tab-synthesis'"
          >
            <!-- <v-card flat width="100%">
              <v-card-text>
                <v-autocomplete
                  v-model="level"
                  hint="Seleccione el nivel, para ver los detalles"
                  :items="levels"
                  label="Nivel"
                  persistent-hint
                  prepend-icon="mdi-elevator"
                  no-data-text="No se tienen Niveles"
                  color="semRj"
                />
              </v-card-text>
            </v-card> -->

            <v-card>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card width="100%">
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Distribución de IEO por Nivel</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text>
                            <apexchart
                              type=donut
                              height=350
                              :options="chartOptionsSynt1"
                              :series="chartSeriesSynt1"
                              :chartKey="chartSynt1Key"
                            />
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex xs12>
                        <v-card width="100%" :key="chartSynt2Key">
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Distribución de las IEO por Indicador</v-toolbar-title>
                          </v-toolbar>

                          <v-card-text>
                            <v-autocomplete
                              v-model="indicator"
                              hint="Seleccione el indicador, para ver los detalles"
                              :items="indicatorsSynt"
                              label="Indicador"
                              persistent-hint
                              prepend-icon="mdi-elevator"
                              no-data-text="No se tienen Niveles"
                              color="semRj"
                            />
                          </v-card-text>

                          <v-card-text v-if="indicator">
                            <apexchart
                              type=donut
                              height=350
                              :options="chartOptionsSynt2"
                              :series="chartSeriesSynt2"
                              :chartKey="chartSynt2Key"
                            />
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <!-- <v-flex xs12>
                        <v-card width="100%">
                          <v-toolbar color="semAz" dark>
                            <v-toolbar-title>Reflexion de este Proyecto</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            {{ projectReflection }}
                          </v-card-text>
                        </v-card>
                      </v-flex> -->
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-card width="100%" :key="prjImgKey">
                      <v-container
                        style="max-height: 934px"
                        class="scroll-y"
                      >
                        <v-img
                          :src="prjImgs[project]"
                          :key="prjImgKey"
                        ></v-img>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab-item
            :value="'tab-traceability'"
          >
            <v-card>
              <!-- <v-flex d-flex xs12> -->
                <v-layout align-center justify-center row fill-height>
                  <v-flex d-flex xs12 sm6>
                    <v-card flat width="50vw">
                      <v-card-text>
                        <apexchart
                          type=bar
                          :options="chartOptionsTrace"
                          :series="chartSeriesTrace"
                          :key="chartTraceKey"
                        />
                      </v-card-text>
                    <!-- </v-card>
                  </v-flex> -->

                  <!-- <v-flex d-flex xs12 sm6>
                    <v-card flat width="100%"> -->
                      <v-card-title semBl-title class="title">
                        Resumen
                      </v-card-title>
                      <v-card-text>
                        El sistema de Monitoreo y evaluación implementado contempla
                        que se debe desarrollar en fases; es así, que de acuerdo a los
                        resultados encontrados en el año 2018 y en el 2019, se presenta
                        el estado de avance de las instituciones y el comparativo
                        entre los dos años.
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              <!-- </v-flex> -->
            </v-card>
          </v-tab-item>

          <v-tab-item
            :value="'tab-reflections'"
          >
            <v-card tile>
              <v-window
                v-model="onboarding"
              >
                <v-window-item
                  v-for="(rec, index) in recommendations"
                  :key="`win-${index}`"
                >
                  <v-responsive :aspect-ratio="5/1">
                    <v-layout align-center justify-center row fill-height>
                      <v-card flat>
                        <v-card-text>
                          {{ rec }}
                        </v-card-text>
                      </v-card>
                    </v-layout>
                  </v-responsive>
                </v-window-item>
              </v-window>

              <v-card-actions class="justify-space-between">
                <v-btn
                  flat
                  @click="prev"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-item-group
                  v-model="onboarding"
                  class="text-xs-center"
                  mandatory
                >
                  <v-item
                    v-for="index in recommendations.length"
                    :key="`btn-${index}`"
                  >
                    <v-btn
                      slot-scope="{ active, toggle }"
                      :input-value="active"
                      icon
                      @click="toggle"
                    >
                      <v-icon>mdi-record</v-icon>
                    </v-btn>
                  </v-item>
                </v-item-group>
                <v-btn
                  flat
                  @click="next"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>

            <!-- <v-card flat tile width="100%">
              <v-layout align-center>
                <v-item-group
                  v-model="reflection"
                  class="shrink mr-4"
                  mandatory
                  tag="v-flex"
                >
                  <v-item
                    v-for="index in recommendations.length"
                    :key="`btn-${index}`"
                  >
                    <div slot-scope="{ active, toggle }">
                      <v-btn
                        :input-value="active"
                        icon
                        @click="toggle"
                      >
                        <v-icon>mdi-record</v-icon>
                      </v-btn>
                    </div>
                  </v-item>
                </v-item-group>

                <v-flex d-flex>
                  <v-window
                    v-model="reflection"
                    class="elevation-1"
                    vertical
                  >
                    <v-window-item
                      v-for="(rec, index) in recommendations"
                      :key="`win-${index}`"
                    >
                      <v-card flat>
                        <v-card-text>
                          {{ rec }}
                        </v-card-text>
                      </v-card>
                    </v-window-item>
                  </v-window>
                </v-flex>
              </v-layout>

            </v-card> -->
          </v-tab-item>

          <!-- <v-tab-item
            :value="'tab-recommendations'"
          >
            <v-card flat width="100%">
              <v-img :src="background">
                <v-card-text
                  v-for="(rec, index) in recommendations"
                  :key="index"
                >
                  {{ rec }}
                </v-card-text>
              </v-img>
            </v-card>
          </v-tab-item> -->
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  // Datos de la aplicación
  import projectsData from './../data/projects'
  import schoolsData from './../data/schools'

  export default {
    name: 'Projects',

    components: {
      apexchart: VueApexCharts,
      // indicators: indicators,
      // traceability: traceability,
      // conclusions: conclusions,
      // recommendations: recommendations,
      // dataSheet: dataSheet
    },

    created () {
      this.loadChart()
      this.updateSynt1()
      this.indicator = this.indicatorsSynt[0]
      this.updateSynt2()
    },

    data: function() {
      return {
        background: require('../assets/background.png'),
        prjImgs: {
          prj01: require('./../assets/projectSyntesis/prj01.png'),
          prj02: require('./../assets/projectSyntesis/prj02.png'),
          prj021: require('./../assets/projectSyntesis/prj021.png'),
          prj03: require('./../assets/projectSyntesis/prj03.png'),
          prj031: require('./../assets/projectSyntesis/prj031.png'),
          prj04: require('./../assets/projectSyntesis/prj04.png'),
          prj05: require('./../assets/projectSyntesis/prj05.png'),
          prj06: require('./../assets/projectSyntesis/prj06.png'),
          prj07: require('./../assets/projectSyntesis/prj07.png'),
          prj08: require('./../assets/projectSyntesis/prj08.png'),
          prj09: require('./../assets/projectSyntesis/prj09.png'),
          prj10: require('./../assets/projectSyntesis/prj10.png')
        },

        lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`,
        projectList: [
          { value: 'prj01', text: 'P01 Conformación de Semilleros TIC.' },
          { value: 'prj02', text: 'P02 Fortalecimiento de las competencias básicas de los estudiantes.' },
          { value: 'prj021', text: 'P02.1 Semilleros de cultura ciudadana.' },
          { value: 'prj03', text: 'P03 Implementación de sistemas de gestión de calidad escolar.' },
          { value: 'prj031', text: 'P03.1 Gestión calidad: Mediadores de comunicación' },
          { value: 'prj04', text: 'P04 Mejoramiento de la gestión curricular.' },
          { value: 'prj05', text: 'P05 Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.' },
          { value: 'prj06', text: 'P06 Recreación en actividades lúdicas para niños y niñas de la primera infancia.' },
          { value: 'prj07', text: 'P07 Adecuación de espacios de ludoteca.' },
          { value: 'prj08', text: 'P08 Recreación a través de la Iniciación y Formación Deportiva.' },
          { value: 'prj09', text: 'P09 Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.' },
          { value: 'prj10', text: 'P10 Capacitación en iniciación y sensibilización artística en comunas y corregimientos.' }
        ],
        project: 'prj01',
        indicator: null,

        tabs: null,
        tabsKey: 0,
        onboarding: 0,

        level: 'Iniciación',
        levels: ['Iniciación', 'Desarrollo', 'Intermedio', 'Maduracion', 'Robusto'],

        chartOptionsTrace: {
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              dataLabels: {
                position: 'top' // top, center, bottom
              }
            }
          },

          colors: ['#4177A6', '#41A66C'],

          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#304758']
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          xaxis: {
            categories: ['Iniciación', 'Intermedio', 'Robusto'],
          },
          yaxis: {
            title: {
              text: 'Número de IEO'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val
              }
            }
          }
        },
        chartSeriesTrace: [],
        chartTraceKey: 0,

        chartOptionsSynt1: {
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: '65%',
                background: 'transparent',
                labels: {
                  show: true,
                  name: {
                    show: true,
                  },
                  value: {
                    show: true,
                    formatter: function (val, w) {
                      let total = w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                      let perc = (val*100) / total
                      return Number.parseFloat(perc).toFixed(1) + ' %'
                    }
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                    }
                  }
                }
              },
            }
          },
          colors: ['#4177A6', '#41A66C', '#D94E5A', '#F2C53D',
                   '#df040b', '#59A8D9', '#b3b2b2', '#f9b233'],
          labels: [],
          legend: {
            show: true,
            floating: true,
            fontSize: '12px',
            position: 'left',
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter: function(seriesName, opts) {
              return seriesName + ": " + opts.w.globals.series[opts.seriesIndex]
            },
            itemMargin: {
              horizontal: 1
            }
          },
          responsive: [{
            breakpoint: 721,
            options: {
              legend: {
                show: false
              }
            }
          }]
        },
        chartSeriesSynt1: [],
        chartSynt1Key: 0,

        chartOptionsSynt2: {
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: '65%',
                background: 'transparent',
                labels: {
                  show: true,
                  name: {
                    show: true,
                  },
                  value: {
                    show: true,
                    formatter: function (val, w) {
                      let total = w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                      let perc = (val*100) / total
                      return Number.parseFloat(perc).toFixed(1) + ' %'
                    }
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                    }
                  }
                }
              },
            }
          },
          colors: ['#4177A6', '#41A66C', '#D94E5A', '#F2C53D',
                   '#df040b', '#59A8D9', '#b3b2b2', '#f9b233'],
          labels: [],
          legend: {
            show: true,
            floating: true,
            fontSize: '12px',
            position: 'left',
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter: function(seriesName, opts) {
              return seriesName + ": " + opts.w.globals.series[opts.seriesIndex]
            },
            itemMargin: {
              horizontal: 1
            }
          },
          responsive: [{
            breakpoint: 721,
            options: {
              legend: {
                show: false
              }
            }
          }]
        },
        chartSeriesSynt2: [],
        chartSynt2Key: 0,
        prjImgKey: 0
      }
    },

    watch: {
      project: function () {
        this.tabs = 'tab-dataSheet'
        this.level = 'Iniciación'
        this.tabsKey += 1
        this.onboarding = 0

        this.loadChart()
        this.updateSynt1()

        this.indicator = this.indicatorsSynt[0]
        this.chartOptionsSynt2.labels = []
        this.chartSeriesSynt2 = []
        this.updateSynt2()
        this.prjImgKey += 1
      },
      indicator: function () {
        this.updateSynt2()
      }
    },

    computed: {
      projects: function () {
        // let prjSch = Object.keys(projectsData)
        let prjts = this.projectList
        // prjts = prjts.filter(
        //   prj => prjSch.includes(prj.value)
        // )
        return prjts
      },
      indicators: function () {
        return projectsData[this.project].indicators
      },
      recommendations: function () {
        return projectsData[this.project].reflections
      },
      prjSchools: function () {
        let schLst = {
           prj01: [],
           prj02: [],
           prj021: [],
           prj03: [],
           prj031: [],
           prj04: [],
           prj05: [],
           prj06: [],
           prj07: [],
           prj08: [],
           prj09: [],
           prj10: []
        }
        schoolsData.forEach(function(sch) {
          let prj = Object.keys(sch.properties.projects)

          for(let i = 0; i < prj.length; i++){
            let obj = {
              ieo: sch.properties.name,
              lvl: sch.properties.projects[prj[i]].trace
            }
            schLst[prj[i]].push(obj)
          }
        })
        return schLst
      },
      schools: function () {
        return this.prjSchools[this.project].filter(sch => sch.lvl === this.level)
      },
      prjObj: function () {
        return projectsData[this.project].obj
      },
      prjAct: function () {
        return projectsData[this.project].actors
      },
      prjCnt: function () {
        return projectsData[this.project].count
      },
      prjPrb: function () {
        return projectsData[this.project].problem
      },
      prjImp: function () {
        return projectsData[this.project].impact
      },
      trace: function () {
        return projectsData[this.project].trace
      },
      dataSheetLink: function () {
        return projectsData[this.project].link
        // return 'https://' + projectsData[this.project].link
        // return './../assets/projectsDataSheet/P1.pdf'
      },

      indicatorsSynt: function () {
        return Object.keys(projectsData[this.project].indicators)
      },
      projectReflection: function () {
        return projectsData[this.project].project_reflection
      },
    },

    methods: {
      loadChart: function() {
        this.chartSeriesTrace = []
        let years = Object.keys(projectsData[this.project].trace)
        years.forEach(function(y){
          let obj = {
            name: y,
            data: Object.values(projectsData[this.project].trace[y])
          }
          this.chartSeriesTrace.push(obj)
        }, this)
        this.chartTraceKey += 1
      },
      updateSynt1: function() {
        this.chartOptionsSynt1.labels =  Object.keys(projectsData[this.project].general)
        this.chartSeriesSynt1 = Object.values(projectsData[this.project].general)
        this.chartSynt1Key += 1
      },
      updateSynt2: function() {
        this.chartOptionsSynt2.labels = Object.keys(projectsData[this.project].indicators[this.indicator])
        this.chartSeriesSynt2 = Object.values(projectsData[this.project].indicators[this.indicator])

        this.chartSynt2Key += 1
      },

      next () {
        this.onboarding = this.onboarding + 1 === this.length
          ? 0
          : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0
          ? this.length - 1
          : this.onboarding - 1
      }
    }
  }
</script>
